/**
 * 將 API 回傳的日期（ISO 字串或 yyyy-MM-dd）轉成 HTML date input 所需的 yyyy-MM-dd。
 * 以 UTC 日曆日解析，與後端以 UTC 儲存之 DATE／Timestamp 語意一致。
 */
export function toDateInputValue(value: string | null | undefined): string {
  if (value == null || value === '') return '';
  const s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const t = Date.parse(s);
  if (Number.isNaN(t)) return '';
  const d = new Date(t);
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
